import React, { useRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Paper, Button } from "@material-ui/core";
import { useFormik } from "formik";
import * as dayjs from "dayjs";
import SingleSelector from "@/components/SingleSelector";
import { CmsHistoryListDatatable } from "@/helpers/cmsHistoryListDatatable";
import { useTranslation } from "@/langs/useTranslation";
import { FormItem } from "@/components/Form";
import DateRangePicker from "@/components/DateRangePicker";
import { useGlobalState } from "@/GlobalProvider";
import { getCMSTemplateType } from "@/apis/apiCollection";
import ViewDevicesModal from "./ViewDevicesModal";
import SearchInput from "@/components/SearchInput";
import useStyles from "@/styles/alarmStyle";

const HistoryList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tableRef = useRef(null);
  const isReset = useRef(true);
  const viewDeviceId = useRef(null);
  const viewDeviceType = useRef(null);

  const [types, setTypes] = useState([
    { id: "", name: t({ defaultMessage: "全部" }) }
  ]);
  const [viewDeviceModalOpen, setViewDeviceModalOpen] = useState(false);

  const history = useHistory();

  const initialValues = {
    keywords: "",
    type: undefined,
    lastUpdateTime: [null, null],
    effectTime: [null, null]
  };

  const { currentCompanyId } = useGlobalState();

  const { values, handleChange, handleSubmit, handleReset } = useFormik({
    initialValues,
    onSubmit: () => {
      handleReloadDataTable();
    }
  });

  const getSearchParams = () => {
    const formValues = isReset.current ? initialValues : values;
    const lastUpdateTime = formValues.lastUpdateTime;
    const effectTime = formValues.effectTime;
    // prettier-ignore
    return {
      keywords: formValues.keywords,
      contentTemplateTypeId: formValues.type,
      lastUpdateBeginTime: lastUpdateTime[0] ? dayjs(lastUpdateTime[0]).valueOf() : undefined,
      lastUpdateEndTime: lastUpdateTime[1] ? dayjs(lastUpdateTime[1]).valueOf() : undefined,
      effectBeginTime: effectTime[0] ? dayjs(effectTime[0]).valueOf() : undefined,
      effectEndTime: effectTime[1] ? dayjs(effectTime[1]).valueOf() : undefined,
    };
  };

  const reloadTableWithGroupId = () => {
    isReset.current = false;
    tableRef.current?.reload();
  };

  const resetTableWithGroupId = () => {
    isReset.current = true;
    tableRef.current?.reload();
  };

  const handleReloadDataTable = reset => {
    if (reset) {
      resetTableWithGroupId();
    } else {
      reloadTableWithGroupId();
    }
  };

  const handleViewDevices = (row, type) => {
    viewDeviceId.current = row.id;
    viewDeviceType.current = type;
    setViewDeviceModalOpen(true);
  };

  const handleRowClick = (e, row) => {
    if (row.contentTemplateTypeName === "Full Screen") {
      history.push(`/cms/template/full-screen/view/${row.id}`);
    } else {
      history.push(`/cms/template/pldm/view/${row.id}`);
    }
  };

  const resetQuery = () => {
    handleReset();
    handleReloadDataTable(true);
  };

  useEffect(() => {
    resetQuery();
  }, [currentCompanyId]);

  useEffect(() => {
    getCMSTemplateType().then(({ contentTemplateTypeList }) => {
      setTypes([
        { id: "", name: t({ defaultMessage: "全部" }) },
        ...contentTemplateTypeList.map(v => ({
          id: v.id,
          name: v.name
        }))
      ]);
    });
  }, []);

  return (
    <div className={classes.main}>
      <Paper elevation={0}>
        <form onSubmit={handleSubmit}>
          <div className={classes.searchAction}>
            <SearchInput
              placeholder={t({ defaultMessage: "搜索" })}
              name="keywords"
              icon={null}
              value={values.keywords}
              onChange={handleChange}
            />
          </div>
          <div className={classes.tableHeader}>
            <div className={classes.tableQueryForm}>
              <FormItem
                label={t({ defaultMessage: "类型" })}
                className={classes.formItem}
              >
                <SingleSelector
                  clearable={false}
                  options={types}
                  name="type"
                  value={values.type}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem
                label={t({ defaultMessage: "最后更新时间" })}
                className={classes.formItem}
              >
                <DateRangePicker
                  name="lastUpdateTime"
                  value={values.lastUpdateTime}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem
                label={t({ defaultMessage: "生效时间" })}
                className={classes.formItem}
              >
                <DateRangePicker
                  name="effectTime"
                  value={values.effectTime}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem className={classes.formItem}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ marginRight: 8 }}
                >
                  {t({ defaultMessage: "查询" })}
                </Button>
                <Button variant="outlined" onClick={resetQuery}>
                  {t({ defaultMessage: "重置" })}
                </Button>
              </FormItem>
            </div>
          </div>
        </form>
        <CmsHistoryListDatatable
          ref={tableRef}
          getSearchParams={getSearchParams}
          onViewDevices={handleViewDevices}
          // onRowClick={handleRowClick}
        />
      </Paper>
      <ViewDevicesModal
        open={viewDeviceModalOpen}
        templateId={viewDeviceId.current}
        viewType={viewDeviceType.current}
        onClose={() => setViewDeviceModalOpen(false)}
      />
    </div>
  );
};

export default HistoryList;
